import { render, staticRenderFns } from "./MediaType.vue?vue&type=template&id=77b3a1f0"
import script from "./MediaType.vue?vue&type=script&lang=js"
export * from "./MediaType.vue?vue&type=script&lang=js"
import style0 from "./MediaType.vue?vue&type=style&index=0&id=77b3a1f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports